import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class IndicadorProgramacionService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getListMeses(): Observable<any> {
    return this.http.get(this.baseUrl + 'listMeses', { headers: this.header(this.token) });
  }

  getListIndicadoresMesPorIndicador(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listIndicadoresMesPorIndicador/' + id, { headers: this.header(this.token) });
  }

  getListIndicadorMesReportado(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listIndicadorMesReportado/' + id, { headers: this.header(this.token) });
  }

  getListIndicadoresAcpMesPorIndicador(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listIndicadoresAcpMesPorIndicador/' + id, { headers: this.header(this.token) });
  }

  postIndicadorMes(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'indicadorMes', bodyString, { headers: this.header(this.token) });
  } 

  putIndicadorMes(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'indicadorMes', bodyString, { headers: this.header(this.token) });
  }

  postIndicadorMesAcp(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'indicadorMesAcp', bodyString, { headers: this.header(this.token) });
  } 

  putIndicadorMesAcp(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'indicadorMesAcp', bodyString, { headers: this.header(this.token) });
  }


  //no usados

 

  getOperacionById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaOperacion/' + id, { headers: this.header(this.token) });
  }



  putOperacion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaOperacion', bodyString, { headers: this.header(this.token) });
  }

  deleteOperacion(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaOperacion/' + id, { headers: this.header(this.token) });
  }

  getUnidadesTechoByOperacionId(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'unidadesTechoByOperacionId/' + id, { headers: this.header(this.token) });
  }

  getListIndicadorMesReportadoACP(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listIndicadorMesReportadoACP/' + id, { headers: this.header(this.token) });
  }

  getListIndicadoresMesPorIndicadorACP(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listIndicadoresMesPorIndicadorACP/' + id, { headers: this.header(this.token) });
  }
}
